import { render, staticRenderFns } from "./totalAndUse.vue?vue&type=template&id=33722631&scoped=true&"
import script from "./totalAndUse.vue?vue&type=script&lang=js&"
export * from "./totalAndUse.vue?vue&type=script&lang=js&"
import style0 from "./totalAndUse.vue?vue&type=style&index=0&id=33722631&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33722631",
  null
  
)

export default component.exports